// import { LoginState } from "redux/types/DataTypes";
import { ActionTypes } from "./constants";
import { Response } from "../../redux/types/DataTypes";

export type ActionType = {
  type:
  | ActionTypes.SEND_OTP_REQUEST
  | ActionTypes.OTP_REQUEST_SUCCESS
  | ActionTypes.OTP_REQUEST_FAIL
  | ActionTypes.VERIFY_OTP_REQUEST
  | ActionTypes.VERIFY_OTP_SUCCESS
  | ActionTypes.VERIFY_OTP_FAIL
  | ActionTypes.EDIT_MAIL
  | ActionTypes.LOGOUT
  | ActionTypes.ERROR_CUSTOMER_SESSION;
  payload: {} | string;
};

//dispatch to send otp request
export const getOtpRequest = (email: string): ActionType => ({
  type: ActionTypes.SEND_OTP_REQUEST,
  payload: { email },
});

//disptach to logout 
export const logout = (): ActionType =>({
  type: ActionTypes.LOGOUT,
  payload: { }
})


//action to set key after successfully get the response
//need to change the datatype of data
export const otpRequestResponse = (actionType: string, data: Response) => ({
  type: ActionTypes.OTP_REQUEST_SUCCESS,
  payload: { actionType, data },
});

//action to set error
export const otpErrorResponse = (actionType: string, error: any) => ({
  type: ActionTypes.OTP_REQUEST_FAIL,
  payload: { actionType, error },
});

//dispatch to verify otp
export const verifyOtpRequest = (email: string, key: string, otp: string) => ({
  type: ActionTypes.VERIFY_OTP_REQUEST,
  payload: { email, key, otp },
});

//dispatch to verify otp
export const verifyCustomerSession = (sessionId: object) => ({
  type: ActionTypes.VERIFY_CUSTOMER_SESSION,
  payload: {sessionId},
});


//dispatch to verify otp
export const verifyCustomerSessionRespose = (actionType: string, data: Response) => ({
  type: ActionTypes.SET_CUSTOMER_SESSION,
  payload: { actionType, data },
});


//action will be executed when otp is verified
export const verifyOtpResponse = (actionType: string, data: Response) => ({
  type: ActionTypes.VERIFY_OTP_SUCCESS,
  payload: { actionType, data },
});

//action will be executed when otp is not verified
export const verifyOtpError = (actionType: string, error: any) => ({
  type: ActionTypes.VERIFY_OTP_FAIL,
  payload: { actionType, error },
});

//customer session error
//dispatch to verify otp
export const verifyCustomerSessionError = (actionType: string, error: any) => ({
  type: ActionTypes.ERROR_CUSTOMER_SESSION,
  payload: { actionType, error },
});


//action to edit mail
export const editMailAction = () => ({
  type: ActionTypes.EDIT_MAIL,
  payload: {},
});
